import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { changeHead } from '../redux/head/headActions';
import { fetchProjects } from '../redux/content/contentActions';

import { MLoader, MHero } from '../components/molecules';
import { OProjects } from '../components/organisme';

import { sliderProject } from '../assets/images/images';
import pageConfig from '../config/page.config';

const mapStateToProps = state => ({
	items: state.content.projects.result,
	isFetching: state.content.isFetching,
});

class ProjectOverviewPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			items: [],
			isFetching: true,
		};
	}

	componentDidMount() {
		this.props.fetchProjects();
		this.props.changeHead({
			id: pageConfig.projectOverview.id,
			title: this.props.intl.formatMessage({ id: pageConfig.projectOverview.title }),
			description: this.props.intl.formatMessage({ id: pageConfig.projectOverview.description }),
			showSocialMedia: true,
		});
	}

	componentWillReceiveProps(props) {
		this.setState({
			items: get(props, 'items', []),
			isFetching: get(props, 'isFetching', false),
		});
	}

	render() {
		let content = <MLoader className="article--loader-hero" />;

		if (!this.state.isFetching) {
			content = <OProjects items={this.state.items} />;
		}

		return (
			<section>
				<MHero
					img={sliderProject}
					currentPage="BREAD_CRUMB.PROJECTS"
					className="a-hero--bottom-align"
				/>
				<article className="section-xx layout-body">
					{content}
				</article>
			</section>
		);
	}
}

ProjectOverviewPage.propTypes = {
	fetchProjects: PropTypes.func.isRequired,
	changeHead: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps, {
	fetchProjects,
	changeHead,
})(injectIntl(ProjectOverviewPage)));



// WEBPACK FOOTER //
// ./src/pages/project-overview.page.js